import React from 'react'

import { IconHappypalSmall } from '@s4l/icons/IconHappypalSmall'
import { IconHappypalLarge } from '@s4l/icons/IconHappypalLarge'

import { BreakpointSizes } from 'src/types/device'
import { useDevice } from 'src/hooks/useDevice'

interface ILogoBrand {
  isResponsive?: boolean
}

const LogoHappypal = ({ isResponsive = false }: ILogoBrand) => {
  const { activeBreakpoint } = useDevice()
  if (isResponsive && activeBreakpoint < BreakpointSizes.M) {
    return <IconHappypalSmall data-testid="logo-happypal-mobile" />
  }

  return <IconHappypalLarge data-testid="logo-happypal-wide" />
}

export default LogoHappypal
